import React from "react";

import { useTranslation } from "react-i18next";

import type { Icon } from "@phosphor-icons/react";

import { type POICategory } from "~/sdks/NeighborhoodMap/types";

import * as styles from "./styles";

export const Category = ({
  category,
  icon: Icon,
  activeCategory,
  onSelectCategory,
}: {
  category: POICategory;
  icon: Icon;
  activeCategory?: POICategory;
  onSelectCategory?: (category: POICategory) => void;
}) => {
  const { t } = useTranslation("neighborhoodMap");

  const handleClick = () => {
    if (onSelectCategory) {
      onSelectCategory(category);
    }
  };

  return (
    <li
      className={styles.container}
      data-active={activeCategory === category}
      onClick={handleClick}
    >
      <Icon className={styles.icon} />
      <p className={styles.text}>{t(`filters.categories.${category}`)}</p>
    </li>
  );
};
